import React, { useEffect, useImperativeHandle, useState } from "react";
import ViewShipperReceiver from "./ViewShipperReceiver";
import { PaginationControls } from "../../../models/pagination";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../../components/loader/loader";
import { ApiUrl } from "../../../config/apiConfig";
import { getData, postData } from "../../../services/Axios/Axios";
import UseCommonService from "../../../services/commonService/commonService";
import messageService from "../../../services/message/messageService";
import Pagination from "../../../components/pagination/pagination";
import NoRecord from "../../../components/NoDataScreen/NoRecord";
import icon from "../../../assets/img/downbtn.svg";
import { showAPiError_mesage } from "../../../services/validationService/validationservice";
import { formatPhoneNumberd } from "../../../services/FormControlService/FormControlServices";
import LinkIcon from "../../../components/UIElements/LinkIcon";
import { ChevronsUpDown } from "lucide-react";
import BlockUnblockButton from "../../../components/UIElements/BlockUnblockButton";
import DeleteButton from "../../../components/UIElements/DeleteButton";
import EditButton from "../../../components/UIElements/EditButton";

interface ShipperReceiverdata {
  addEditModelShipper: any;
  setSelectedRows1: any;
  selectedRows1: any;
}

const ShipperReceiver = React.forwardRef((props: ShipperReceiverdata, ref) => {
  const [ids, setIds] = useState<number[]>([]); // or the appropriate type for your IDs

  // const ShipperReceiver = React.forwardRef(
  //   ({ addEditModelShipper }: any, ref) => {
  const { show, hide } = useLoader();
  const [allData, setAllData] = useState<any>([]);
  const [SingleUser, setSingleUser] = useState("");
  const [searchdataa, setSearchQuery] = useState<any>("");

  const [pagination, setPagination] = useState(new PaginationControls());
  const [startIndex, setStartIndex] = useState(0);

  const [selectAll, setSelectAll] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    getDataALL();

    return () => {
      console.log("Component unmounted");
    };
  }, [pagination.page]);

  useEffect(() => {
    setSelectAll(
      allData.length > 0 && props.selectedRows1.length === allData.length
    );
  }, [props.selectedRows1, allData]);

  const getDataALL = async (searchdataa?: any) => {
    const skip = (pagination.page - 1) * pagination.limit;
    const obj: any = { skip_number: skip };
    const isSearchRequest = Boolean(searchdataa && searchdataa.trim());
    if (isSearchRequest) {
      obj.search = searchdataa;
    }
    try {
      const response = await getData(
        ApiUrl.listShipperReceiver,
        obj,
        isSearchRequest ? undefined : { show, hide }
      );
      console.log("Data posted successfully:", response);
      const ids = response.data.map((item: any) => item._id);

      setIds(ids); // Assuming setIds is a state updater function for IDs
      setAllData(sortByShowOnTop(response.data));
      setPagination((prevPagination) => ({
        ...prevPagination,
        count: response.total_count,
      }));
      setStartIndex(
        (pagination.page === 0 ? 0 : (pagination.page - 1) * pagination.limit) +
        1
      );
    } catch (error: any) {
      const message = error?.response?.data?.message;
      showAPiError_mesage(message);
    }
  };

  console.log(allData, "allData>>>>>>>>>>.");

  const handlePageChange = (selectedPage: { selected: number }) => {
    const newPage = selectedPage.selected + 1;
    setPagination((prevPagination) => ({
      ...prevPagination,
      page: newPage,
    }));
  };

  let addEdite = (data?: any) => {
    console.log(data, "datatrailer>>>>>>>>>>>");
    if (data) {
      setSingleUser(data);
      const state = data;
      navigate("/TrailerDetails", { state });
    }
  };

  useImperativeHandle(ref, () => ({
    getDataALL,
    handleSearchSubmit,
    handleSearchChange,
    handleDeleteSelected3,
    handleDeleteSelectedAll3,
  }));

  const handleSearchChange = (event: any) => {
    setSearchQuery(event);
  };

  const handleSearchSubmit = () => {
    console.log("object");
    getDataALL(searchdataa);
  };

  let blockUnblock = async (data: any) => {
    const messageServices = messageService();
    messageServices
      .confirm(`Block this Vendor`, "")
      .then(async (res) => {
        if (res.value) {
          const obj = {
            _id: data._id,
            isBlocked: !data.isBlocked,
          };
          let response = postData(ApiUrl.addEditshipperReciever, obj);
          if (await response) {
            getDataALL();
            const commonService = UseCommonService();
            commonService.checkBlockUnblock(data);
          }
        }
      });
  };

  let deleteData = async (data: any) => {
    const messageServices = messageService();

    messageServices
      .confirm(`delete this Vendor`, "")
      .then(async (res) => {
        if (res.value) {
          const obj = {
            _id: data._id,
            isDeleted: !data.isDeleted,
          };
          let response = postData(ApiUrl.addEditshipperReciever, obj);
          if (await response) {
            getDataALL();
            messageServices.toast(
              "success",
              messageServices.message.deleteSuccess
            );
          }
        }
      });
  };

  const handleSelectAll = (e: any) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    props.setSelectedRows1(checked ? allData.map((item: any) => item._id) : []);
  };

  const handleRowSelect = (id: any) => {
    props.setSelectedRows1((prev: any) => {
      if (prev.includes(id)) {
        return prev.filter((itemId: any) => itemId !== id);
      } else {
        return [...prev, id];
      }
    });
  };
  console.log(props.selectedRows1, "selectedRowsselectedRows");
  const handleDeleteSelected3 = async () => {
    const messageServices = messageService();
    messageServices
      .confirm(`Delete selected Vendor`, "")
      .then(async (res) => {
        if (res.value) {
          const obj = {
            _id: props.selectedRows1,
            // isBulkDelete: true,
          };

          try {
            await postData(ApiUrl.deleteShipperReciever, obj);
            getDataALL();
            messageServices.toast(
              "success",
              messageServices.message.deleteSuccess
            );
            props.setSelectedRows1([]);
            setSelectAll(false);
          } catch (error) { }
        }
      });
  };

  console.log(props.selectedRows1, "selectedRowsselectedRowsselectedRows");

  const handleDeleteSelectedAll3 = async () => {
    const messageServices = messageService();
    messageServices
      .confirm(`Delete All Vendor`, "")
      .then(async (res) => {
        if (res.value) {
          const obj = {
            _id: ids,
            isBulkDelete: true,
          };

          try {
            await postData(ApiUrl.deleteShipperReciever, obj);
            getDataALL();
            messageServices.toast(
              "success",
              messageServices.message.deleteSuccess
            );
            props.setSelectedRows1([]);
            setSelectAll(false);
          } catch (error) { }
        }
      });
  };

  function sortByShowOnTop(arr: any[]): any[] {
    return arr.sort((a, b) => {
      // If showOnTop is true, move it before false
      return (b.showOnTop ? 1 : 0) - (a.showOnTop ? 1 : 0);
    });
  }

  return (
    <>
      <div className="tablebox">
        <div className="tablebox12">
          <div className="scrollbar-box assetsdriver sdfrf">

            <table className="border-collapse  text-black w-full">
              <thead className="whitespace-nowrap bg-[#F6F6F7] border border-[#E2E2E2] ">
                <tr className="text-[13px] font-bold  bg-customGray">
                  <th className="px-3 py-2 text-center border border-[#E2E2E2] ">
                    <div className="flex items-center justify-between">
                      <div className="checkboxinlinnre">
                        <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                        />{" "}
                        ALL
                      </div>
                    </div>
                  </th>

                  <th className="  px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>S. No</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center border w-[20%] border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Company Name</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="  px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Phone Number</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="  px-3 py-2 w-[20%]  text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Address</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>



                  <th className=" px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Website</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="whitespace-nowrap border border-[#E2E2E2] ">
                {allData.map((data: any, index: number) => (
                  <tr key={index} className="text-[12px]">
                    <td className="  px-3  border border-[#E2E2E2]">
                      <input
                        type="checkbox"
                        checked={props.selectedRows1.includes(data._id)}
                        onChange={() => handleRowSelect(data._id)}
                      />
                    </td>
                    <td className=" px-3 border border-[#E2E2E2]">
                      {startIndex + index}</td>
                    <td className="px-3 border w-[20%] border-[#E2E2E2]">
                      {data?.companyName
                        ? data.companyName.charAt(0).toUpperCase() +
                        data.companyName.slice(1).toLowerCase()
                        : "--"}  {data.showOnTop &&
                          <span className="bg-green-100  text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm  text-green-600 ml-3">Top</span>
                      }

                    
                    </td>
                    <td className=" px-3 border border-[#E2E2E2]">  {data?.contactPhoneNumber
                      ? formatPhoneNumberd(
                        data?.contactPhoneNumber
                      )
                      : "--"}</td>
                    <td className=" px-3 border w-[20%] border-[#E2E2E2]"> {data?.companyPhysicalAddress ? data?.companyPhysicalAddress : "--"}</td>

                    <td className=" px-2 border border-[#E2E2E2]  ">
                      <div className="flex items-center justify-center">

                        <LinkIcon url={data?.website_url} />
                      </div>
                    </td>


                    <td className="text-center items-center px-2 py-[2px] border border-[#E2E2E2]">
                      <div className="flex justify-center items-center gap-2">
                        {/* Block / Unblock */}
                        <BlockUnblockButton isBlocked={data.isBlocked} onClick={() => blockUnblock(data)}></BlockUnblockButton>

                        {/* Delete */}
                        <DeleteButton onClick={() => deleteData(data)} />

                        {/* Edit */}
                        <EditButton onClick={() => props.addEditModelShipper(data)} />
                      </div>
                    </td>


                  </tr>
                ))}
              </tbody>
            </table>


            {/* <table className="load-table w-100">
              <tr className="load-list-head">
                <th className="load-list-th">
                  <div className="checkboxinlinnre">
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />{" "}
                    ALL
                  </div>
                </th>
                <th className="load-list-th">S. No</th>
                <th className="load-list-th">Company Name</th>
                <th className="load-list-th">Phone Number</th>
                <th className="load-list-th">Address</th>
                <th className="load-list-th">Website</th>

                <th className="load-list-th text-center">Actions</th>
              </tr>
              {allData.map((data: any, index) => (
                <tr className="load-list-body" key={index}>
                  <td className="load-list-td">
                    <input
                      type="checkbox"
                      checked={props.selectedRows1.includes(data._id)}
                      onChange={() => handleRowSelect(data._id)}
                    />
                  </td>
                  <td className="load-list-td">{startIndex + index}</td>
                  <td
                    className="load-list-td uppercase"
                    style={{
                      textTransform: "none",
                    }}
                  >
                    {data?.companyName
                      ? data.companyName.charAt(0).toUpperCase() +
                        data.companyName.slice(1).toLowerCase()
                      : "--"}
                  </td>
                
                  <td className="load-list-td line_phone_number">
                    {data?.contactPhoneNumber
                      ? formatPhoneNumberd(
                          data?.contactPhoneNumber
                        )
                      : "--"}
                  </td>
                  <td className="load-list-td">
                    {data?.companyPhysicalAddress ? data?.companyPhysicalAddress : "--"}
                  </td>
                  <td className="load-list-td underline blu cursur">
                   
                                      <LinkIcon url={data.website_url} />

                  </td>

                  <td className="load-list-td text-center">
                    <div className="dropdown">
                      <img
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        src={icon}
                        alt=""
                      />

                      <ul className="dropdown-menu">
                        <li>
                          <a
                            className="dropdown-item"
                            onClick={() => blockUnblock(data)}
                          >
                            {data.isBlocked === true ? "Unblock" : "Block"}
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            onClick={() => deleteData(data)}
                          >
                            Delete
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            onClick={() => props.addEditModelShipper(data)}
                          >
                            Edit
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            </table> */}
            {!allData.length && (
              <NoRecord noDataText="No data available in Vendor" />
            )}
          </div>
        </div>
        {allData.length > 0 && (
          <Pagination pagination={pagination} onPageChange={handlePageChange} />
        )}
      </div>
    </>
  );
});

export default ShipperReceiver;
